export default "__VITE_ASSET__kgJfRSmk__"